// src/components/common/AlertMessage.js
import React from 'react';
import { Alert } from 'react-bootstrap';

/**
 * Componente de alerta reutilizavel
 * @param {string} message - Mensagem a exibir
 * @param {string} variant - Tipo do alerta (success, danger, warning, info)
 * @param {function} onClose - Callback para fechar o alerta
 * @param {boolean} dismissible - Se pode ser fechado pelo usuario
 */
export const AlertMessage = ({
  message,
  variant = 'success',
  onClose,
  dismissible = true
}) => {
  if (!message) return null;

  return (
    <Alert
      variant={variant}
      dismissible={dismissible}
      onClose={onClose}
      className="mb-3"
    >
      {message}
    </Alert>
  );
};

/**
 * Alerta de sucesso
 */
export const SuccessAlert = ({ message, onClose }) => (
  <AlertMessage message={message} variant="success" onClose={onClose} />
);

/**
 * Alerta de erro
 */
export const ErrorAlert = ({ message, onClose }) => (
  <AlertMessage message={message} variant="danger" onClose={onClose} />
);

/**
 * Alerta de aviso
 */
export const WarningAlert = ({ message, onClose }) => (
  <AlertMessage message={message} variant="warning" onClose={onClose} />
);

/**
 * Alerta informativo
 */
export const InfoAlert = ({ message, onClose }) => (
  <AlertMessage message={message} variant="info" onClose={onClose} />
);

export default AlertMessage;
